<template>
    <div class="countyPickerWrap fc" @touchmove.prevent>
        <!-- <p>{{myAddressProvince}} {{myAddressCity}} {{myAddresscounty}}</p> -->
        <mt-picker
            :slots="myAddressSlots"
            @change="onMyAddressChange"
            :visibleItemCount="7"
            :showToolbar="true"
            :itemHeight="itemHeight"
        >
            <div class="toolBar frr ac jsb">
                <span class="confirmTxt" @click="confirm">确定</span>
            </div>
        </mt-picker>
    </div>
</template>

<script>
import { Picker } from "mint-ui";
import countyData from "../../common/js/county_data.json";
export default {
    data() {
        return {
            addrData: [],
            provinceArr: [],
            cityArr: [],
            countyArr: [],
            provinceIdx: 0,
            cityIdx: 0,
            countyIdx: 0,
            provincecode: "",
            citycode: "",
            countycode: "",
            myAddressSlots: [
                {
                    flex: 1,
                    defaultIndex: 1,
                    // values: Object.keys(countyData), //省份数组
                    className: "slot1",
                    textAlign: "center",
                },
                {
                    divider: true,
                    content: "-",
                    className: "slot2",
                },
                {
                    flex: 1,
                    // values: [],
                    // values: this.getCity('北京市'),
                    className: "slot3",
                    textAlign: "center",
                },
                {
                    divider: true,
                    content: "-",
                    className: "slot4",
                },
                {
                    flex: 1,
                    // values: this.getarea('北京市','市辖区'),
                    className: "slot5",
                    textAlign: "center",
                },
            ],
            myAddressProvince: "省",
            myAddressCity: "市",
            myAddresscounty: "区/县",
            itemHeight: 66,
        };
    },
    props: {
        regionInit: {
            type: Boolean,
            default: false,
        },
        provinceTxt: {
            type: String,
            default: "",
        },
        cityTxt: {
            type: String,
            default: "",
        },
        countyTxt: {
            type: String,
            default: "",
        },
    },
    components: {
        "mt-picker": Picker,
    },
    beforeCreate() {
        this.$nextTick(() => {
            let scrollHeight = document.body.scrollHeight;
            this.itemHeight = Math.ceil(scrollHeight / 16);
            console.log("scrollHeight", scrollHeight, this.itemHeight);
        });
    },
    mounted() {
        this.getAddrData();
        // this.$nextTick(() => {
        //     //vue里面全部加载好了再执行的函数  （类似于setTimeout）
        //     this.myAddressSlots[0].defaultIndex = 0;
        // });
    },
    methods: {
        getAddrData() {
            this.$post({
                method: "drama.area.list",
            }).then((res) => {
                if (res.success) {
                    this.addrData = res.data.itemlist;
                    this.provinceArr = res.data.itemlist.map(
                        (i) => i.provincename
                    );
                    this.myAddressSlots[0].values = res.data.itemlist.map(
                        (i) => i.provincename
                    );
                    if (this.provinceTxt) {
                        console.log("provinceTxt", this.provinceTxt);
                        this.myAddressSlots[0].defaultIndex = this.provinceArr.indexOf(
                            this.provinceTxt
                        );
                        this.provinceIdx = this.provinceArr.indexOf(
                            this.provinceTxt
                        );
                        this.myAddressSlots[2].values = res.data.itemlist[
                            this.provinceIdx
                        ].cityList.map((i) => i.cityname);
                        this.cityArr = res.data.itemlist[
                            this.provinceIdx
                        ].cityList.map((i) => i.cityname);
                        if (this.cityTxt) {
                            this.myAddressSlots[2].defaultIndex = this.cityArr.indexOf(
                                this.cityTxt
                            );
                            this.cityIdx = this.cityArr.indexOf(this.cityTxt);
                            this.myAddressSlots[4].values = res.data.itemlist[
                                this.provinceIdx
                            ].cityList[this.cityIdx].countyList.map(
                                (i) => i.countyname
                            );
                            this.countyArr = res.data.itemlist[
                                this.provinceIdx
                            ].cityList[this.cityIdx].countyList.map(
                                (i) => i.countyname
                            );
                        }
                        if (this.countyTxt) {
                            this.myAddressSlots[4].defaultIndex = this.countyArr.indexOf(
                                this.countyTxt
                            );
                        }
                        // this.$emit(
                        //     "getVal",
                        //     this.provinceTxt,
                        //     this.cityTxt,
                        //     this.countyTxt,
                        //     this.provincecode,
                        //     this.citycode,
                        //     this.countycode
                        // );
                    } else {
                        this.myAddressSlots[0].defaultIndex = 0;
                        this.myAddressSlots[2].values = res.data.itemlist[0].cityList.map(
                            (i) => i.cityname
                        );
                        this.myAddressSlots[2].defaultIndex = 0;
                        this.myAddressSlots[4].values = res.data.itemlist[0].cityList[0].countyList.map(
                            (i) => i.countyname
                        );
                        this.myAddressSlots[4].defaultIndex = 0;
                    }
                }
            });
        },
        confirm() {
            this.$emit("confirmPick");
        },
        getCity: function (pro) {
            return Object.keys(countyData[pro]);
        },
        //这个就是初始化逻辑，其实就是获取省下的某个市下的区，取决于你的json数据格式
        getarea: function (pro, city) {
            return countyData[pro][city];
        },
        onMyAddressChange(picker, values) {
            // console.log("values",values)

            // if (countyData[values[0]]) {
            if (this.regionInit) {
                //这个判断类似于v-if的效果（可以不加，但是vue会报错，很不爽）
                this.provinceIdx = this.provinceArr.indexOf(values[0]);
                picker.setSlotValues(
                    1,
                    this.addrData[this.provinceIdx].cityList.map(
                        (i) => i.cityname
                    )
                );
                this.cityArr = this.addrData[this.provinceIdx].cityList.map(
                    (i) => i.cityname
                );
                this.$nextTick(() => {
                    this.cityIdx = this.cityArr.indexOf(values[1]);
                    picker.setSlotValues(
                        2,
                        this.addrData[this.provinceIdx].cityList[
                            this.cityIdx
                        ].countyList.map((i) => i.countyname)
                    );
                    this.$nextTick(() => {
                        this.countyArr = this.addrData[
                            this.provinceIdx
                        ].cityList[this.cityIdx].countyList.map(
                            (i) => i.countyname
                        );
                        this.countyIdx = this.countyArr.indexOf(values[2]);
                        console.log(this.countyIdx);
                    });
                });

                // picker.setSlotValues(1, Object.keys(countyData[values[0]])); // Object.keys()会返回一个数组，当前省的数组
                // picker.setSlotValues(2, countyData[values[0]][values[1]]); // 区/县数据就是一个数组

                this.myAddressProvince = values[0];
                this.myAddressCity = values[1];
                this.myAddresscounty = values[2];
                this.provincecode = this.addrData[
                    this.provinceIdx
                ].provincecode;
                this.citycode = this.addrData[this.provinceIdx].cityList[
                    this.cityIdx
                ].citycode;
                this.countycode = this.addrData[this.provinceIdx].cityList[
                    this.cityIdx
                ].countyList[this.countyIdx].countycode;
                console.log(this.provincecode, this.citycode, this.countycode);
                this.$emit(
                    "getVal",
                    this.myAddressProvince,
                    this.myAddressCity,
                    this.myAddresscounty,
                    this.provincecode,
                    this.citycode,
                    this.countycode
                );
            }
            // else {
            //     this.regionInit = true
            // }
        },
    },
};
</script>
<style lang="scss">
.countyPickerWrap {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 5;
    .picker {
        background: #fff;
        .picker-item {
            font-size: 26px;
            // height: 200px;
            // line-height: 200px;
        }
        .picker-toolbar {
            height: 80px;
            border-bottom: 1px solid #dededf;
            .toolBar {
                width: 100%;
                padding: 0 30px;
                box-sizing: border-box;
                height: 80px;
                font-size: 28px;
                .confirmTxt {
                    color: #e42f46;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/countyPicker.vue